import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import axios, { API } from "@/lib/api";

export default function GalleryPreview() {
  const [albums, setAlbums] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/public/gallery/albums`).then(({ data }) => setAlbums(data.slice(0, 4))).catch(() => {});
  }, []);

  if (albums.length === 0) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-testid="gallery-preview-section">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Galeri</span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Momen Bersama Jamaah</h2>
        </div>
        <Button variant="outline" data-testid="gallery-view-all-button" onClick={() => navigate("/galeri")} className="gap-2 rounded-full">
          Lihat Semua <ArrowRight className="h-4 w-4" />
        </Button>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {albums.map((a) => (
          <button
            key={a.id}
            data-testid={`gallery-album-${a.id}`}
            onClick={() => navigate("/galeri")}
            className="group relative aspect-square overflow-hidden rounded-2xl"
          >
            <img src={a.cover_image} alt={a.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <p className="absolute bottom-3 left-3 right-3 text-left text-sm font-medium text-white">{a.title}</p>
          </button>
        ))}
      </div>
    </section>
  );
}
